// src/components/Banner/Banner.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();

  const handlePrimary = () => navigate("/contact");
  const handleSecondary = () => navigate("/services");

  return (
    <section className="cta4" aria-labelledby="cta4-heading">
      <div className="cta4-wrap">
        <div className="cta4-surface">
          {/* subtle background ornaments */}
          <div className="cta4-glow" aria-hidden="true" />
          <div className="cta4-grid" aria-hidden="true" />

          <div className="cta4-main">
            {/* LEFT */}
            <div className="cta4-copy">
              <p className="cta4-kicker">Growth clarity in one call</p>

              <h2 id="cta4-heading" className="cta4-title">
                A simple plan to improve your{" "}
                <span>website, leads, and marketing.</span>
              </h2>

              <p className="cta4-sub">
                We’ll quickly review your current setup, identify the biggest
                bottleneck, and share a focused 7–14 day action plan. You’ll leave
                with clear next steps—whether you work with us or not.
              </p>

              <div className="cta4-actions">
                <button
                  className="cta4-btn cta4-btnPrimary"
                  type="button"
                  onClick={handlePrimary}
                >
                  Get a free plan call
                </button>

                <button
                  className="cta4-btn cta4-btnGhost"
                  type="button"
                  onClick={handleSecondary}
                >
                  See services
                </button>
              </div>

              <div className="cta4-note">
                <span className="cta4-dot" aria-hidden="true" />
                <span>
                  No long contracts. Clear deliverables. Quick wins first, then
                  compounding improvements.
                </span>
              </div>
            </div>

            {/* RIGHT */}
            <aside className="cta4-side" aria-label="What you get">
              <div className="cta4-sideHead">
                <p className="cta4-sideLabel">What you’ll get</p>
                <p className="cta4-sideSub">
                  A quick review + a practical plan you can execute immediately.
                </p>
              </div>

              <div className="cta4-list">
                <div className="cta4-li">
                  <span className="cta4-bullet" aria-hidden="true" />
                  <div>
                    <div className="cta4-liTitle">Top 3 fixes</div>
                    <div className="cta4-liText">Highest impact improvements first</div>
                  </div>
                </div>

                <div className="cta4-li">
                  <span className="cta4-bullet" aria-hidden="true" />
                  <div>
                    <div className="cta4-liTitle">Funnel clarity</div>
                    <div className="cta4-liText">What to change on pages + CTAs</div>
                  </div>
                </div>

                <div className="cta4-li">
                  <span className="cta4-bullet" aria-hidden="true" />
                  <div>
                    <div className="cta4-liTitle">Tracking checklist</div>
                    <div className="cta4-liText">Know what’s working (and what isn’t)</div>
                  </div>
                </div>
              </div>

              <div className="cta4-pills" aria-hidden="true">
                <span className="cta4-pill">Website</span>
                <span className="cta4-pill">SEO</span>
                <span className="cta4-pill">Ads</span>
                <span className="cta4-pill">CRM</span>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
